module.exports = __webpack_public_path__ + "img/24.9c2b6950.jpg";